import { StatusEnum } from '../../Enum/StatusEnum';
import BaseEntity from '../BaseEntity.model';

export default interface IVisionAndHearing extends BaseEntity {
    MemberId: string;
    HasVisionImpairment?: boolean;
    IsAIHasVisionImpairment?: boolean;
    IsGlassesUsed?: boolean;
    IsAIIsGlassesUsed?: boolean;
    HasHearingImpairment?: boolean;
    IsAIHasHearingImpairment?: boolean;
    IsAidsUsed?: boolean;
    IsAIIsAidsUsed?: boolean;
    Status: StatusEnum;
    Score?: number;
}

export class VisionAndHearing implements IVisionAndHearing {
    Id: string;
    MemberId: string;
    HasVisionImpairment?: boolean;
    IsAIHasVisionImpairment?: boolean;
    IsGlassesUsed?: boolean;
    IsAIIsGlassesUsed?: boolean;
    HasHearingImpairment?: boolean;
    IsAIHasHearingImpairment?: boolean;
    IsAidsUsed?: boolean;
    IsAIIsAidsUsed?: boolean;
    Status: StatusEnum;
    Score?: number;

    constructor() {
        this.MemberId = '';
    }
}
